import React from 'react';
import { BookOpen } from 'lucide-react';
export function Header() {
  return <header className="w-full py-6 px-4 border-b border-brown/10 bg-cream/80 backdrop-blur-sm sticky top-0 z-50" data-id="element-101">
      <div className="max-w-3xl mx-auto flex flex-col items-center justify-center text-center space-y-1" data-id="element-102">
        <div className="flex items-center gap-2 text-forest" data-id="element-103">
          <BookOpen size={24} className="opacity-80" data-id="element-104" />
          <h1 className="font-handwriting text-4xl font-bold tracking-wide" data-id="element-105">
            Napftagebuch
          </h1>
        </div>
        <p className="font-serif text-sm text-brown/80 italic" data-id="element-106">
          Ehrliche Geschichten aus dem Hundealltag
        </p>
      </div>
    </header>;
}